// extracted by mini-css-extract-plugin
module.exports = {"root":"NavbarItemMobile_root__5ltxS","section":"NavbarItemMobile_section__lA_Av","body":"NavbarItemMobile_body__r_Rad"};